import styled from "styled-components";

const SettingsActionDiv = styled.div`
  margin-top: 30px;
  text-align: right;
  ${({ theme }) =>
    theme?.sizes?.isMobile &&
    `
    display: flex;
    flex-direction: column;
    gap: 8px;
  `};
`;

type SettingActionsProps = { children: React.ReactNode };

function SettingActions({ children }: SettingActionsProps) {
  return <SettingsActionDiv>{children}</SettingsActionDiv>;
}

export default SettingActions;
